<div *ngIf="galleryData.length" class="gallery">
	<div (click)="closeGallery()" class="clickOutsideElements"></div>
	<button
		mat-fab
		color="primary"
		class="closeDialogButton position-absolute top-0 mt-20 end-0"
		(click)="closeGallery()"
	>
		<i class="fas fa-times"></i>
	</button>
	<button class="previousButton" (click)="previousImage()" mat-fab color="primary">
		<i class="fas fa-angle-left"></i>
	</button>

	<img
		*ngIf="selectedImage.mimeType.includes('image'); else previewNotAvailable"
		class="obj-cover max-h-85 max-w-80"
		alt="Załącznik"
		[src]="selectedImage.src"
	/>
	<ng-template #previewNotAvailable>
		<mat-card appearance="outlined" style="z-index: 20" class="text-center min-w-35">
			<mat-card-title>Podgląd niedostępny</mat-card-title>
			<mat-card-content>{{ selectedImage.filename }}</mat-card-content>
			<button
				color="primary"
				class="downloadButton"
				(click)="downloadService.downloadAttachment(selectedImage)"
				mat-raised-button
			>
				Pobierz załącznik
			</button>
		</mat-card>
	</ng-template>
	<div class="d-flex flex-wrap position-absolute w-100 justify-content-center start-0 bottom-5">
		<div
			*ngFor="let item of galleryData; let i = index"
			class="mt-2 rounded-circle cursor-pointer pagination"
			(click)="selectImage(i)"
			[style.background-color]="galleryData.indexOf(selectedImage) === i ? '#3f51b5' : '#fff'"
		></div>
	</div>
	<button class="nextButton" (click)="nextImage()" mat-fab color="primary">
		<i class="fas fa-angle-right"></i>
	</button>
</div>
